import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-left-navigation-menu',
  standalone: true,
  imports: [RouterModule, TooltipModule],
  templateUrl: './left-navigation-menu.component.html',
  styleUrl: './left-navigation-menu.component.scss',
})
export class LeftNavigationMenuComponent {
  @Input() items: MenuItem[] = [];
  @Input() userDisplayName = '';
  @Input() userName = '';

  isExpanded = false;

  get profileName(): string {
    return this.userDisplayName || this.userName;
  }

  get initials(): string {
    
    const nameParts = this.profileName.trim().split(/\s+/).filter(Boolean);

    if (nameParts.length === 0) {
      return '';
    }

    return `${nameParts[0][0]}${nameParts.length > 1 ? nameParts[nameParts.length - 1][0] : ''}`.toUpperCase();
  }

  expand(): void {
    this.isExpanded = true;
  }

  collapse(): void {
    this.isExpanded = false;
  }
}